import { ErrorBoundary } from "@sentry/react";
import Markdown from "react-markdown";

import { Attribution, Typography } from "~/common/components";
import { ReimbursementExportDownloadLink } from "~/providers/components/pdf/ReimbursementExport/ReimbursementExportDownloadLink";
import { ConsultationReimbursementReport } from "~/providers/utils/types/consultation";

interface SubmittedReimbursementReportProps {
  data: ConsultationReimbursementReport;
}

export const SubmittedReimbursementReport = ({
  data,
}: SubmittedReimbursementReportProps) => {
  const { completed_at: completedAt, completed_by, data: reportData } = data;
  const completedBy = completed_by?.team_member;

  return (
    <div className="flex flex-col gap-4 pb-6">
      <div className="flex w-full justify-between">
        <Typography className="text-sm text-gray-35">
          <Attribution
            firstName={completedBy?.name}
            lastName={completedBy?.last_name}
            date={completedAt ?? undefined}
          />
        </Typography>
        <div className="-my-2.5">
          <ErrorBoundary>
            <ReimbursementExportDownloadLink />
          </ErrorBoundary>
        </div>
      </div>
      <div className="prose prose-sm max-w-none text-gray-35">
        <Markdown>{reportData.final_note}</Markdown>
      </div>
    </div>
  );
};
